import React, { useState } from 'react';
import { Button, Form, FormInput, FormSubmitButton, notification } from '@digital/ui';
import { Layout, Card, Row, Col } from 'antd';
import { Redirect } from 'react-router';
import { useActions } from '@digital/ui/lib/store';
import Title from 'antd/lib/typography/Title';
import LoginBoxLogo from '../../../public/images/logotipo_mrn_verde.png';
import { getPermissions, loginFornecedor } from '../../api/account';
import LoginHeaderLogo from '../../../public/images/logo_mrn_branca.png';
import Microsoft from '../../../public/images/microsoft.png';

import { useActions } from '@digital/ui/lib/store';
import { GoogleReCaptchaProvider, GoogleReCaptcha } from "react-google-recaptcha-v3";
import './custom.css';
import packageJson from "package.json"
import { loginRequest } from '@app/config/msalConfig';
import { useMsal } from '@azure/msal-react';
import { setAuthorizationToken } from "../../api/api";

interface LoginProps {
    isAuthenticated: boolean;
    onAuthenticate: (isAuthenticated: boolean) => void;
}

const Login = ({ isAuthenticated, onAuthenticate }: LoginProps) => {
    const { instance } = useMsal();


    const [token, setToken] = useState("");
    const [refreshReCaptcha, setRefreshReCaptcha] = useState(false);
    const loadPermissions = useActions(state => state.permission.loadPermissions);
    const [isLoading, setIsLoading] = useState<boolean>();
    const handleSubmit = async (values: any) => {
        setIsLoading(true);
        const resp = await loginFornecedor({ ...values, token });
        if (resp && resp.valid) {
            localStorage.setItem('isAuthenticated', 'true');
            localStorage.setItem('userLogadoId', resp.userLogadoId);
            localStorage.setItem('isMRN', resp.isMRN);
            localStorage.setItem('codigoUsuario', resp.codigoUsuario);
            localStorage.setItem('idtoken', resp.access_token);
            localStorage.setItem('expiration', resp.expires_in);

            onAuthenticate(true);

            if (resp.isFirstAccess == true) {
                loadPermissions(['dfc2fd92-3024-4641-9219-ea357a4eeeb3']);
                window.location.href = '/primeiroAcesso';
            } else {
                loadPermissions(resp.permissoes);
                window.location.href = resp.url;
            }
        } else {
            setRefreshReCaptcha(!refreshReCaptcha);
            setIsLoading(false);
        }
    };

    const verifyRecaptchaCallback = React.useCallback((token) => {
        setToken(token)
    }, []);


    const handleMicrosoftLogin = async () => {
        console.log("[SSO] Iniciando login Microsoft (redirect)");
            
           instance.loginRedirect({
             scopes: [
               "openid",
               "profile",
               "email",
               "api://f67c02dc-7e1f-4472-b084-9456524a4f40/access_as_user",
             ],
           });
    };




    return <>
        <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_RECAPTCHA_KEY}>
            <GoogleReCaptcha
                className="google-recaptcha-custom-class"
                onVerify={verifyRecaptchaCallback}
                refreshReCaptcha={refreshReCaptcha}
            />
        </GoogleReCaptchaProvider>
        {
            isAuthenticated ? (
                <Redirect to="/" />
            ) : (
                <>
                    {
                        <style
                            dangerouslySetInnerHTML={{
                                __html: `header.ant-app-header.ant-layout-header {display: none;} .ant-app-header-actions .ant-btn i.icon {color:#D0D0D0} .ant-app-header-actions .ant-btn i.icon:hover {color:#FFFFFF} .ant-app-header-actions .ant-btn:hover i.icon, .ant-app-header-actions .ant-btn:focus i.icon {padding: 0px; color: #FFFFFF; background-color: transparent; border-color: transparent;} .ant-app-header .ant-app-header-logo span {height: 48px; display: flex; align-items: center} .ant-app-header-logo > .anticon {display:none} .ant-app-header-title:before {content: url(${LoginHeaderLogo}); height: 28px; margin-left: 2px}`,
                            }}
                        />
                    }
                    <div className="login-view">
                        <Layout>
                            <div className="image">
                            </div>
                            <Card>
                                <Form onSubmit={handleSubmit}>
                                    <div className="login-box">
                                        <Row>
                                            <Col>
                                                <div className="login-box-logo">
                                                    <img src={LoginBoxLogo} />
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col className="login-box-col">
                                                <div className="login-box-group">
                                                    <h2 className="login-box-title-sig">SGE</h2>
                                                </div>
                                                <div className="login-box-title">Login</div>
                                            </Col>
                                        </Row>
                                    </div>
                                    <div className="nome-do-sistema">
                                        Sistema de Gestão Econômica v{packageJson.version}
                                    </div>
                                    <br />
                                    <FormInput
                                        className="login-user-name"
                                        name="username"
                                        required
                                        placeholder="ui.commons.user"
                                    />
                                    <FormInput
                                        className="login-user-password"
                                        name="password"
                                        required
                                        type="password"
                                        placeholder="ui.commons.password"
                                    />

                                      <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }} className="actions">
               
                                        <FormSubmitButton
                                            title="Entrar"
                                            loading={isLoading}
                                            noIcon
                                            type="primary"
                                            htmlType="submit"
                                        />

<div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          color: '#999',
                          fontSize: 12,
                          margin: '4px 0',
                        }}>
                        ————— ou —————
                      </div>
                      <Button
                        type="primary"
                        onClick={handleMicrosoftLogin}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          gap: 8,
                        }}>
                        <img src={Microsoft} alt="Microsoft" style={{ height: 18 }} />
                        Entrar com Microsoft
                      </Button>

                                    
                    </div>

                                </Form>

                            </Card>
                        </Layout>
                    </div>
                </>
            )
        }
    </>
};

export default Login;